import React, { Fragment, useState } from 'react'
import Loader from 'react-loader-spinner'
import isNull from 'lodash/isNull'
import Cookies from 'js-cookie'
import get from 'lodash/get'
import { createUseStyles } from 'react-jss'

import useFacebook from '../../../../custom-hooks/useFacebook'
import { authenticateUser, registerUser, authWithFacebook } from '../../../../services/auth'
import { consumePropositionInvite } from '../../../../services/proposition'
import InviteSteakHolders from '../InviteSteakHolders'
import GeneralInput from 'components/GeneralInput'
import SignupForm from 'components/SignupForm'

const INITIAL_SIGNUP_FORM = {
  name: '',
  email: '',
  password: '',
  phone: '',
  cpf: '',
}

const INITIAL_LOGIN_FORM = {
  email: '',
  password: '',
}

const FORM_TRANSLATION_MAP = {
  email: 'Email',
  password: 'Senha',
}

const Invite = ({ invite }) => {
  const classes = useStyles()
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [facebookName, setFacebookName] = useState('')
  const [facebookUrl, setFacebookUrl] = useState('')
  const [success, setSuccess] = useState('')
  const [guest, setGuest] = useState('')
  const [guestImage, setGuestImage] = useState('')
  const [visibleEmail, setVisibleEmail] = useState(false)
  const [visibleConsumeButton, setVisibleConsumeButton] = useState(false)
  const [signupForm, setSignupForm] = useState(INITIAL_SIGNUP_FORM)
  const [loginForm, setLoginForm] = useState(INITIAL_LOGIN_FORM)
  const [loginFormError, setLoginFormError] = useState(INITIAL_LOGIN_FORM)

  const { fbSdkLoaded } = useFacebook()
  const inviteId = get(invite, 'id')
  const landLordImage = get(invite, 'landlord.profile_image')
  const landLord = get(invite, 'landlord.name')
  const tenantImage = get(invite, 'tenant.image')
  const tenantName = get(invite, 'tenant.name')

  const setEmailVisibility = () => setVisibleEmail(!visibleEmail)

  const cleanup = () => {
    setLoginForm(INITIAL_LOGIN_FORM)
    setSignupForm(INITIAL_SIGNUP_FORM)
  }

  const updateField = (e) => {
    setSignupForm({
      ...signupForm,
      [e.target.name]: e.target.value,
    })
  }

  const updateLoginField = (e) => {
    setLoginForm({
      ...loginForm,
      [e.target.name]: e.target.value,
    })
  }

  const acceptInvite = () => {
    const apiAccessToken = Cookies.get('apiAccessToken')

    consumePropositionInvite(apiAccessToken, inviteId)
      .then(({ data }) => {
        if (data.data.message) {
          setGuest(facebookName)
          setGuestImage(facebookUrl)
          setSuccess('Parabéns, você faz parte agora de uma nova negociação!')
          setError('')
        }
      })
      .catch((error) => {
        console.log('acceptInvite -> error', { error })
        setError('Não foi possível adicionar a sua pessoa à negociação')
      })
  }

  const processFacebookData = async (accessToken) => {
    setIsLoading(true)

    try {
      const { data } = await authWithFacebook(accessToken)
      if (data.user) {
        await setVisibleConsumeButton(true)
        setIsLoading(false)
        Cookies.set('apiAccessToken', data.accessToken)
      }
    } catch (error) {
      console.log('processFacebookData -> error', { error })
      setError('Não foi possível salvar os seus filtros no momento. Tente novamente mais tarde')
    } finally {
      setIsLoading(false)
    }
  }

  const onClickFacebook = (e) => {
    e.preventDefault()

    window.FB.login(
      (response) => {
        if (response.status === 'connected') {
          // Logged into your webpage and Facebook.
          processFacebookData(response.authResponse.accessToken)
        } else {
          // The person is not logged into your webpage or we are unable to tell.
          console.log("couldn't log in with facebook")
        }
      },
      { scope: 'public_profile,email' },
    )
  }

  const submitValue = async (type) => {
    if (type === 'register') {
      registerUser(signupForm)
        .then(({ data }) => {
          if (!isNull(data.id)) {
            setFacebookName(data.name)
            setFacebookUrl(data.profile_image)
            setVisibleEmail(!visibleEmail)
            setIsLoading(false)
          }
        })
        .catch((error) => {
          console.log('registerUser -> error', { error })
          setError('Não foi possível realizar o seu cadastro')
        })
    }

    if (type === 'login') {
      const hasError = validateLoginForm()

      if (hasError) return

      authenticateUser(loginForm.email, loginForm.password)
        .then((response) => {
          if (!isNull(response.accessToken)) {
            Cookies.set('apiAccessToken', response.accessToken)
            setFacebookName(response.user.name)
            setFacebookUrl(response.user.profile_image)
            cleanup()
            setVisibleConsumeButton(true)
          }
        })
        .catch((error) => {
          console.log('authenticateUser -> error', { error })
          setError('Não foi possivel realizar o seu login, email ou senha estão incorretos')
          setTimeout(() => setError(''))
          setIsLoading(false)
        })
    }
  }

  const setLoginError = (property, error) => {
    setLoginFormError((prev) => ({
      ...prev,
      [property]: error,
    }))
  }

  const validateLoginForm = () => {
    let hasError = false
    Object.keys(loginForm).forEach((key) => {
      if (!loginForm[key]) {
        setLoginError(key, `${FORM_TRANSLATION_MAP[key]} é um campo obrigatório`)
        hasError = true
      }
    })

    if (!!loginForm.email && loginForm.email.indexOf('@') === -1) {
      setLoginError('email', 'Por favor insira um Email válido')
      hasError = true
    }

    if (!!loginForm.password && loginForm.password.length < 8) {
      setLoginError('password', 'Senha precisa ter no mínimo 8 caracteres')
      hasError = true
    }

    return hasError
  }

  return (
    <Fragment>
      <div className='divisor' />

      <InviteSteakHolders
        landLordImage={landLordImage}
        landLord={landLord}
        tenantImage={tenantImage}
        tenant={tenantName}
        thirdPartImage={guestImage}
        thirdPart={guest}
      />

      <div className='divisor' />

      <div className='divisor' />

      <Fragment>
        {Boolean(success) && <p style={{ color: 'green', textAlign: 'center', margin: 16 }}>{success}</p>}
      </Fragment>

      <Fragment>
        {Boolean(error) && <p style={{ color: 'red', textAlign: 'center', margin: 16 }}>{error}</p>}
      </Fragment>
      {isLoading ? (
        <Loader type='Oval' color='#00BFFF' height={60} width={60} style={{ marginTop: '50px' }} />
      ) : (
        <div>
          {!visibleConsumeButton && (
            <div>
              {visibleEmail === false ? (
                <form className='share-signup_form'>
                  <SignupForm
                    form={signupForm}
                    hasCpf
                    headline='Complete o seu Cadastro'
                    subheadline='para fazer parte dessa negociação'
                    submitButtonText='Participar da negociação'
                    isLoading={isLoading || !fbSdkLoaded}
                    onClickFacebook={onClickFacebook}
                    onSubmit={() => submitValue('register')}
                    containerStyle={classes.formContainer}
                    updateField={updateField}
                  />
                </form>
              ) : (
                <div>
                  <div className='share-signup'>
                    <div className='share-signup_title'>Entre com sua conta</div>
                    <div className='share-signup_subtitle'>para fazer parte dessa negociação</div>
                  </div>
                  <form className='share-signup_form'>
                    <GeneralInput
                      className={classes.input}
                      value={loginForm.email}
                      label='Email'
                      type='email'
                      name='email'
                      handleChange={updateLoginField}
                      error={loginFormError.email}
                    />
                    <GeneralInput
                      className={classes.input}
                      value={loginForm.password}
                      label='Senha'
                      type='password'
                      name='password'
                      handleChange={updateLoginField}
                      error={loginFormError.password}
                    />
                  </form>
                </div>
              )}

              <div className='share-signup_button_groups'>
                {visibleEmail && (
                  <button
                    className='share-signup_button_negotiation'
                    onClick={() => (visibleEmail ? submitValue('login') : submitValue('register'))}
                  >
                    Entrar
                  </button>
                )}

                <button className='share-signup_button' onClick={() => setEmailVisibility()}>
                  {!visibleEmail ? 'Entrar com Email' : 'Criar conta'}
                </button>
              </div>
            </div>
          )}

          {visibleConsumeButton && (
            <div className='share-signup_button_groups'>
              <div className='divisor' />
              <button
                disabled={Boolean(success)}
                className={
                  Boolean(success) ? 'share-signup_disable_button' : 'share-signup_button_negotiation'
                }
                onClick={() => acceptInvite()}
              >
                Aceitar Convite
              </button>
            </div>
          )}
        </div>
      )}
    </Fragment>
  )
}

const useStyles = createUseStyles({
  formContainer: {
    width: '100%',
    paddingBottom: '0',
  },
  input: {
    width: '100%',
    textAlign: 'left',
  },
})

export default Invite
